import { render } from "./ProductBoxWideSegmentConversion.vue?vue&type=template&id=93937814&ts=true"
import script from "./ProductBoxWideSegmentConversion.vue?vue&type=script&lang=ts"
export * from "./ProductBoxWideSegmentConversion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__